
/****************************************************
 * Module Name:  packetProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";
export default class PacketProxy {

    static AddSubPackets = (data, kapanid, packetid, callback) => {
        restAPICall(Constants.MANAGER_URL + `/packet/subpacket/${kapanid}/${packetid}`,
            'post',
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            'application/json',
            0
        )
            .then(response => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static AddPackets = (data, kapanid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/${kapanid}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddPackageDetail = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllMyPacketToreceive = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/receive`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddPacketIssue = (data, callback) => {
        restAPICall(Constants.MANAGER_URL + `/packet/issue`, 'post', Constants.userToken, undefined, JSON.stringify(data), 'application/json', 0)
            .then(response => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static AddPacketIssueWithinDepartment = (data, callback) => {
        restAPICall(Constants.MANAGER_URL + `/packet/issue/force`, 'post', Constants.userToken, undefined, JSON.stringify(data), 'application/json', 0)
            .then(response => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static MarkPacketReceive = (data, callback) => {
        restAPICall(Constants.MANAGER_URL + `/packet/receive`, 'post', Constants.userToken, undefined, JSON.stringify(data), 'application/json', 0)
            .then(response => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static GetMaxPacketIdFromKapanId = (kapanid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/maxpacketid/${kapanid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMaxPacketIdFromKapanIdAndPacketId = (kapanid, packetid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/maxpacketid/${kapanid}/${packetid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdatePacketNextProcess = (kapanid, packetid, processid, callback) => {
        let params = {
            processid: processid,
        };
        restAPICall(
            Constants.MANAGER_URL + `/packet/process/${kapanid}/${packetid}`,
            "put",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetFurtherPacketDetail = (kapanid, packetid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/${kapanid}/${packetid}/detail`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static MergeToPacketZero = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/merge`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CancelPacketIssue = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/cancel`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static NotifyUser = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/notify`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddPacketsVideo = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/video`,
            'post',
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            'application/json',
            0
        )
            .then(response => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static GetAllPacketVideo = (id, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/${id}/pendingvideos`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static GetAllMyPacket = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/mypackets`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllMyPacketByDepartment = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/mydepartmentpackets`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddConvertToStone = (data, locationid, callback) => {
        restAPICall(Constants.MANAGER_URL + `/packet/converttostone/${locationid}`, 'post', Constants.userToken, undefined, JSON.stringify(data), 'application/json', 0)
            .then(response => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static AddConvertToBucket = (data, locationid, callback) => {
        restAPICall(Constants.MANAGER_URL + `/mix/packet/addtomix/${locationid}`, 'post', Constants.userToken, undefined, JSON.stringify(data), 'application/json', 0)
            .then(response => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static GetAllMyPacketWithEvaluation = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/mypackets/evaluation`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleFurtherPackets = (id, packet, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packet/break/${id}/${packet}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}